import React, { useEffect, useState } from "react";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
} from "@react-pdf/renderer";
import moment from "moment";
import axios from "axios";
import { useLocation } from "react-router-dom";
import config from "../../../config";
import Header from "../../../Pdf/PrintHeaderAccount";
import { Spin } from "antd";
import pdfStyles from "../../../Pdf/pdfStyles";
import PrintFooter from "../../../Pdf/PrintFooter";

const PrintDipSummary = () => {
  const location = useLocation();
  const UserID = localStorage.getItem("ID");
  const AccessKey = localStorage.getItem("AccessKey");
  const [DipSummaryData, setDipSummaryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("");

  useEffect(() => {
    document.title = "Print DIP Summary";
    setLoading(true);
    const urlParams = new URLSearchParams(location.search);
    const StartDate = urlParams.get("StartDate");
    const EndDate = urlParams.get("EndDate");
    const ProductID = urlParams.get("ProductID");

    const payload = {
      UserID: UserID,
      AccessKey: AccessKey,
      StartDate: StartDate,
      EndDate: EndDate,
      PageNo: 1,
      PageSize: 5000,
      ProductID: ProductID ? parseInt(ProductID, 10) || 0 : 0,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Product/GetDIPSummary",
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setData(response.data);
          setDipSummaryData(response.data.listofLedger);
        }
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  }, [location.search, AccessKey, UserID]);

  const generateData = () => {
    if (DipSummaryData.length > 0) {
      return DipSummaryData.map((item, index) => {
        return (
          <View key={index} style={pdfStyles.row}>
            <View style={[pdfStyles.td, { width: 30 }]}>
              <Text style={pdfStyles.tdValue}>{index + 1}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 80 }]}>
              <Text style={pdfStyles.tdValue}>
                {moment(item.Dated).format("DD MMM YYYY")}
              </Text>
            </View>
            <View style={[pdfStyles.td, { width: 150 }]}>
              <Text style={pdfStyles.tdValue}>{item.Name}</Text>
            </View>

            <View style={[pdfStyles.td, { width: 80 }]}>
              <Text style={pdfStyles.tdValue}>{item.TotalPhysicalStock}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 80 }]}>
              <Text style={pdfStyles.tdValue}>{item.TotalSystemStock}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 70 }]}>
              <Text style={pdfStyles.tdValue}>{item.DifferenceQuantity}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 90 }]}>
              <Text style={[pdfStyles.tdValue, { textAlign: "right" }]}>
                {item.AdjustmentRate}
              </Text>
            </View>
            <View style={[pdfStyles.td, { width: 80 }]}>
              <Text style={[pdfStyles.tdValue, { textAlign: "right" }]}>
                {item.AdjustmentAmount}
              </Text>
            </View>
          </View>
        );
      });
    }
  };

  const MyDocument = () => (
    <Document>
      <Page size="A4" style={pdfStyles.page}>
        <Header />
        <View style={pdfStyles.section}>
          <View style={pdfStyles.title}>
            <Text style={pdfStyles.pagetitle}>Dip Summary</Text>
          </View>
          <View style={pdfStyles.table}>
            <View style={pdfStyles.tableHead}>
              <View style={[pdfStyles.th, { width: 30 }]}>
                <Text style={pdfStyles.thValue}>SR.</Text>
              </View>
              <View style={[pdfStyles.td, { width: 80 }]}>
                <Text style={pdfStyles.thValue}>Dated</Text>
              </View>
              <View style={[pdfStyles.th, { width: 150 }]}>
                <Text style={pdfStyles.thValue}>Product</Text>
              </View>

              <View style={[pdfStyles.th, { width: 80 }]}>
                <Text style={pdfStyles.thValue}>Dip Stock</Text>
              </View>
              <View style={[pdfStyles.th, { width: 80 }]}>
                <Text style={pdfStyles.thValue}>Actual Stock</Text>
              </View>
              <View style={[pdfStyles.th, { width: 70 }]}>
                <Text style={pdfStyles.thValue}>Difference</Text>
              </View>
              <View style={[pdfStyles.th, { width: 90 }]}>
                <Text style={[pdfStyles.thValue, { textAlign: "right" }]}>
                  Adjustment Rate
                </Text>
              </View>
              <View style={[pdfStyles.th, { width: 80 }]}>
                <Text style={[pdfStyles.thValue, { textAlign: "right" }]}>
                  Amount
                </Text>
              </View>
            </View>

            {generateData()}

            <View style={[pdfStyles.tableHead, { fontSize: "10pt" }]}>
              <View style={[pdfStyles.th, { width: 500, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>Total Gain</Text>
              </View>
              <View style={[pdfStyles.th, { width: 70, textAlign: "left" }]}>
                <Text style={pdfStyles.thValue}>{data.totalGain}</Text>
              </View>
            </View>
            <View style={pdfStyles.tableHead}>
              <View style={[pdfStyles.th, { width: 500, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>Total Loss</Text>
              </View>
              <View style={[pdfStyles.th, { width: 70, textAlign: "left" }]}>
                <Text style={pdfStyles.thValue}>{data.totalLoss}</Text>
              </View>
            </View>
          </View>
          <View
            style={{ marginBottom: 50, marginTop: 0, top: 10, bottom: 10 }}
            fixed
          >
            <Text
              style={{ fontSize: "8pt" }}
              render={({ pageNumber, totalPages }) =>
                `Page ${pageNumber} / ${totalPages}`
              }
            />
          </View>
        </View>
        <PrintFooter fixed />
      </Page>
    </Document>
  );

  return (
    <>
      <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
        {loading ? (
          <div
            style={{
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spin />
          </div>
        ) : (
          <PDFViewer width="100%" height="100%" fileName="sample.pdf">
            <MyDocument />
          </PDFViewer>
        )}
      </div>
    </>
  );
};

export default PrintDipSummary;
